// Module
var code = "<a data-bind=\"visible: ViewModel.DisplayValue\" class=\"remove\"> </a>";
// Exports
export default code;